import { useAuthStore } from '@hooks/useAuthStore'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@components/ui/tabs'
import { CalendarDays, Clock, Palmtree } from 'lucide-react'
import { AvailabilitySummaryStrip } from '@components/availability/AvailabilitySummaryStrip'
import { AvailabilityCalendarGrid } from '@components/availability/AvailabilityCalendarGrid'
import { AvailabilitySettingsCard } from '@components/availability/AvailabilitySettingsCard'
import { ExceptionsTab } from '@components/availability/ExceptionsTab'
import { VacationsTab } from '@components/availability/VacationsTab'

export function MyAvailabilityPage() {
  const user = useAuthStore((s) => s.user)

  if (!user) return null

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-headline text-2xl font-light italic tracking-tight text-ml-primary">
          Disponibilidad
        </h1>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Configure los horarios de consulta, Dr. {user.last_name}
        </p>
      </div>

      <AvailabilitySummaryStrip doctorId={user.id} />

      <Tabs defaultValue="schedule" className="space-y-4">
        <TabsList className="w-full sm:w-auto">
          <TabsTrigger value="schedule" className="flex items-center gap-1.5">
            <CalendarDays className="h-3.5 w-3.5" />
            Horario Semanal
          </TabsTrigger>
          <TabsTrigger value="exceptions" className="flex items-center gap-1.5">
            <Clock className="h-3.5 w-3.5" />
            Excepciones
          </TabsTrigger>
          <TabsTrigger value="vacations" className="flex items-center gap-1.5">
            <Palmtree className="h-3.5 w-3.5" />
            Vacaciones
          </TabsTrigger>
        </TabsList>

        <TabsContent value="schedule" className="space-y-4">
          <AvailabilitySettingsCard doctorId={user.id} />
          <AvailabilityCalendarGrid doctorId={user.id} />
        </TabsContent>

        <TabsContent value="exceptions">
          <ExceptionsTab doctorId={user.id} />
        </TabsContent>

        <TabsContent value="vacations">
          <VacationsTab doctorId={user.id} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
